import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { initSentry } from '@/lib/sentry';
import { store } from '@/app/store';
import { AppErrorBoundary } from '@/routes/AppErrorBoundary';
import { router } from '@/routes/router';
// Sora, self-hosted: no request to Google Fonts, no CSP exception, and it works
// with no network in dev. The "Variable" cut brings the whole weight axis in one
// file, which is what the headings at 800 need.
import '@fontsource-variable/sora';
import './index.css';

// Before anything else in the app: the SDK instruments `fetch`, navigation and
// uncaught errors as it initialises, and whatever happens before that nobody
// sees. In particular the `pageload` transaction — the one that measures how
// long the app takes to become usable — starts here.
//
// With no `VITE_SENTRY_DSN` it initialises nothing, which is the case in dev and
// in the tests.
initSentry(import.meta.env);

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('The #root element was not found');
}

createRoot(rootEl).render(
  <StrictMode>
    {/* Outside the Provider: an error while building the store also has to
        reach Sentry and paint something, not a blank screen. */}
    <AppErrorBoundary>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </AppErrorBoundary>
  </StrictMode>,
);
